import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import urls from "../../routes";
import {
  useClerk,
  useUser as useClerkUser,
  useOrganizationList,
  useSession,
} from "@clerk/clerk-react";
import useUser from "../../providers/UserProvider/useUser";
import { jwtDecode } from "jwt-decode";

function InviteAccepted() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { signOut } = useUser();
  const { setActive } = useClerk();
  const { session } = useSession();
  const { isLoaded, isSignedIn } = useClerkUser();
  const { userMemberships, isLoaded: isOrganizationListLoaded } =
    useOrganizationList({
      userMemberships: {
        infinite: true,
      },
    });

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const status = searchParams.get("__clerk_status");
  const ticket = searchParams.get("__clerk_ticket");

  useEffect(() => {
    const decodedTicket = ticket ? jwtDecode(ticket) : null;

    async function signOutAndRedirect() {
      const orgId =
        decodedTicket &&
        "oid" in decodedTicket &&
        typeof decodedTicket.oid === "string"
          ? decodedTicket.oid
          : null;

      if (
        userMemberships.data?.some(
          (membership) => membership.organization.id === orgId,
        )
      ) {
        if (session?.lastActiveOrganizationId) {
          localStorage.setItem(
            "previousOrganizationId",
            session.lastActiveOrganizationId,
          );
        }

        await setActive({
          organization: orgId,
        });
        await session?.touch();

        window.location.href = urls.home;
        return;
      }

      await signOut();

      await navigate(
        status === "sign_up"
          ? `${urls.signUp}?__clerk_ticket=${ticket}&__clerk_status=${status}`
          : `${urls.signIn}?__clerk_ticket=${ticket}&__clerk_status=${status}`,
      );
    }

    if (!isLoaded) {
      return;
    }

    if (!isSignedIn) {
      void navigate(
        status === "sign_up"
          ? `${urls.signUp}?__clerk_ticket=${ticket}&__clerk_status=${status}`
          : `${urls.signIn}?__clerk_ticket=${ticket}&__clerk_status=${status}`,
      );
    } else if (isOrganizationListLoaded) {
      void signOutAndRedirect();
    }
  }, [
    isLoaded,
    isOrganizationListLoaded,
    isSignedIn,
    navigate,
    session,
    setActive,
    signOut,
    status,
    ticket,
    userMemberships.data,
  ]);

  return null;
}

export default InviteAccepted;
